<template>
    <div class="input-details">
        <h6>{{nodeDetails.name}}</h6>
        <p>Region: {{nodeDetails.region || 'no region defined'}}</p>
        <p>Status : <i :class="iconClass"></i> <strong :class="textClass">{{textValue}}</strong></p>
        <p v-if="userIsAtLeastAdmin || userIsEntityAdmin(entityUid)">Arn: {{nodeDetails.arn ? nodeDetails.arn : 'No arn given'}}</p>
        <p>Bitrate: {{nodeDetails.bitrate || nodeDetails.bitrate === 0 ? nodeDetails.bitrate : 'No bitrate given'}}</p>
        <p v-if="userIsAtLeastAdmin || userIsEntityAdmin(entityUid)">Flow status: {{nodeDetails.flow_status}}</p>
        <p v-if="nodeDetails.source_connected === true">
            <i class="el-icon-success text-success"></i> <strong class="text-success">Source connected</strong>
        </p>
        <p v-else>
            <i class="el-icon-error text-danger"></i> <strong class="text-danger">Source not connected</strong>
        </p>
        <p>Connected outputs (configurations): {{ nodeDetails.connected_outputs ? nodeDetails.connected_outputs : 0 }}</p>
        <p v-if="userIsAtLeastAdmin || userIsEntityAdmin(entityUid)">Unrecovered packets: {{ nodeDetails.unrecovered_packets ? nodeDetails.unrecovered_packets : 0 }}</p>
        <actions-buttons
            v-if="(userIsAtLeastAdmin || userIsEntityAdmin(entityUid))"
            :details="nodeDetails"
            :resource="resource"
            :resource-is-feed="resourceIsFeed"
            @watchModelStatus="watchModelStatus"
        ></actions-buttons>
    </div>
</template>

<script>
import ActionsButtons from './ResourceActionBtn/actions-buttons.vue';
import {mapGetters} from 'vuex';
export default {

    components: {
        ActionsButtons,
    },

    props: {
        nodeDetails: {
            type: Object,
            required: true
        },
        resource:{
            type: Object,
            default: null
        },
        resourceIsFeed:{
            type: Boolean,
        },
        entityUid:{
            type: String,
            required: true,
        }

    },

    data: function(){
        return {
            iconClassByStatus: {
                'success': 'el-icon-success text-success',
                'unstable': 'el-icon-warning text-warning',
                'failure': 'el-icon-error text-danger',
            },
            textClassByStatus: {
                'success': 'text-success',
                'unstable': 'text-warning',
                'failure': 'text-danger',
            },
            textValueByStatus: {
                'success': 'OK',
                'unstable': 'WARNING',
                'failure': 'ERROR',
            }
        };
    },

    computed: {
        ...mapGetters([
            'userIsAtLeastAdmin',
            'userIsEntityAdmin'
        ]),
        iconClass() {
            return this.iconClassByStatus[this.nodeDetails.status];
        },
        textClass() {
            return this.textClassByStatus[this.nodeDetails.status];
        },
        textValue() {
            return this.textValueByStatus[this.nodeDetails.status];
        }
    },

    mounted: function(){

    },

    methods: {
        watchModelStatus(model){
            this.$emit('watchModelStatus', model);
        }
    },
};
</script>

<style lang="scss">
.input-details {
    .main-and-backup {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Monitoring/deliveryDetails.vue